import React, { useState, useEffect } from "react";

import MoodOutlinedIcon from "@mui/icons-material/MoodOutlined";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import SendIcon from "@mui/icons-material/Send";

import { ACTIONS as CHAT_ACTIONS } from "../../redux/chat";
import useFilePicker from "../../hooks/useFilePicker";
import { getImageAspectRatio } from "../../utils";

import SearchArea from "../search-area";
import IconPicker from "../icon-picker";
import SendImageModal from "../send-image-modal";
import StyledInputField from "./styles";

const InputField = ({
  onChange,
  onSend,
  noActive,
  onSendImage,
  icon,
  noSendButton,
}) => {
  const [emojiPickerOpen, setEmojiPickerOpen] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [imageModal, setImageModal] = useState({
    image: null,
    extension: null,
  });

  const [text, setText] = useState("");

  const onImagePick = (file) => {
    const data = file?.filesContent[0]?.content;

    let extension = file?.plainFiles[0]?.type;
    extension = extension.replace("image/", "");

    setImageModal({ data: data, extension });
    setOpenImageModal(true);
  };

  const closeModalButtonHandler = () => {
    setOpenImageModal(false);
  };

  const onCloseModalHandler = () => {
    setOpenImageModal({ data: null, extension: null });
  };

  const onPickError = (error) => {
    console.log(error);
  };

  const { openFilePicker, filesContent, loading } = useFilePicker(
    onImagePick,
    onPickError,
    [".jpg", ".png", ".avif", ".jpeg", ".webp"]
  );

  const onImageSendHandler = (payload) => {
    const { data, extension } = imageModal;

    if (data && extension && onSendImage) {
      getImageAspectRatio(data, (aspectRatio) => {
        const isHorizontal = aspectRatio > 1;

        onSendImage({ data, extension, isHorizontal });
        closeModalButtonHandler();
      });
    }
  };

  const onSendHandler = () => {
    const input = document.getElementById("chat-input-search-area");
    const value = input.value;

    setEmojiPickerOpen(false);

    input.value = "";
    setText("");

    if (onSend) {
      onSend(value);
    }
  };

  const onKeyDownHandler = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSendHandler();
    }
  };

  const openEmojiPickerHandler = (e) => {
    e.stopPropagation();
    setEmojiPickerOpen(true);
  };

  const closeEmojiPickerHandler = () => {
    setEmojiPickerOpen(false);
  };

  const emojiClickHandler = (res) => {
    const emoji = res.emoji;

    const input = document.getElementById("chat-input-search-area");
    input.value += emoji;

    setText((prev) => `${prev}${emoji}`);
  };

  const onTextInputChange = (e) => {
    const value = e.target.value;
    setText(value);
  };

  useEffect(() => {
    if (emojiPickerOpen) {
      window.addEventListener("click", closeEmojiPickerHandler);
    } else {
      window.removeEventListener("click", closeEmojiPickerHandler);
    }

    return () => {
      window.removeEventListener("click", closeEmojiPickerHandler);
    };
  }, [emojiPickerOpen]);

  useEffect(() => {
    window.addEventListener("keydown", onKeyDownHandler);

    return () => window.removeEventListener("keydown", onKeyDownHandler);
  }, [onKeyDownHandler, onKeyDownHandler]);

  return (
    <>
      <StyledInputField
        style={{
          opacity: noActive ? 0.5 : 1,
          pointerEvents: noActive ? "none" : "auto",
        }}
      >
        <IconPicker
          color="grey"
          open={emojiPickerOpen}
          onIconClick={openEmojiPickerHandler}
          top="0px"
          transform="translateY(calc(-100% - 0.5rem))"
          onEmojiClick={emojiClickHandler}
        />
        <SendImageModal
          open={openImageModal}
          image={imageModal.data}
          onCloseButton={closeModalButtonHandler}
          onClose={onCloseModalHandler}
          onSend={onImageSendHandler}
          // todo
          loading={false}
        />
        <div className="input-field">
          <div className="input">
            {icon ? (
              <div className="icon-section">{icon()}</div>
            ) : (
              <div className="icon-section" onClick={openEmojiPickerHandler}>
                <MoodOutlinedIcon sx={{ fill: "grey" }} />
              </div>
            )}

            <SearchArea
              disabled={noActive}
              onChange={onChange}
              placeholder="Mensaje..."
              id="chat-input-search-area"
              onInputChange={onTextInputChange}
            />

            {!noSendButton && (
              <div className="icon-section">
                <div
                  className={`left-icon-container ${
                    text ? "left-icon-container--send" : ""
                  }`}
                >
                  {text ? (
                    <SendIcon
                      onClick={onSendHandler}
                      className="action-icon send-icon"
                      sx={{ fill: "white" }}
                    />
                  ) : (
                    <CameraAltIcon
                      className="action-icon camera-icon"
                      onClick={openFilePicker}
                      sx={{ fill: "grey" }}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </StyledInputField>
    </>
  );
};

export default InputField;
